// extracted by mini-css-extract-plugin
module.exports = {"multiPlayContainer":"_24e7690"};